// api/default-operation.ts
import { registerSubscription } from "@adornis/baseql/metadata/register.js";
import { publishFilter } from "@adornis/baseql/server/context.js";
import { watchQuery } from "@adornis/baseql/server/watchQuery.js";
import { from, switchMap } from "rxjs";
import { ViewProfile } from "../db/ViewProfile.js";
var subscribeAllViewProfiles = registerSubscription({
  operationName: "subscribeAllViewProfiles",
  type: () => [ViewProfile],
  params: [{ type: () => String, name: "category" }],
  resolve: (category) => (gqlFields) => {
    return from(publishFilter(ViewProfile)).pipe(
      switchMap((filter) => {
        const selector = { category };
        return watchQuery(
          ViewProfile._collectionName,
          filter ? { $and: [filter, selector] } : selector,
          {
            projection: gqlFields
          }
        );
      })
    );
  }
});
export {
  subscribeAllViewProfiles
};
